import React from "react";
import { Card, Form, Input, Button, Alert, Space } from "antd";

import useUpdate from "hooks/useUpdate";

import { name_regexp } from "helpers/regexp";
import useFormErrors from "hooks/useFormErrors";
import { useParams } from "react-router-dom";
import { useIssueKinds } from "context/providers/issue_kinds";

const BasicInfo = ({ setOpenPreviewModal }) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const { data, refetch } = useIssueKinds();
  const issue_kind = data.find((item) => item.id === id);

  const path = `/issue_kinds/${id}`;
  const { is_saving, update } = useUpdate({
    path,
    form,
    onSuccess: refetch,
  });
  const { has_error, onFieldsChange } = useFormErrors();

  const full_name = issue_kind?.full_name || "";

  return (
    <Form
      form={form}
      layout="vertical"
      onFieldsChange={onFieldsChange}
      initialValues={{
        name: issue_kind?.name || "",
        full_name,
      }}
      onFinish={(values) => update(values)}
      className="m-b-20"
    >
      {(values) => {
        const dirty = values.full_name !== full_name || values.name !== issue_kind?.name;
        return (
          <Card
            title="Podstawowe informacje"
            extra={
              <Space>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => setOpenPreviewModal(true)}
                >
                  Podgląd
                </Button>
                <Button
                  disabled={!dirty || has_error}
                  loading={is_saving}
                  type="primary"
                  htmlType="submit"
                >
                  Zapisz
                </Button>
              </Space>
            }
          >
            {dirty && (
              <Alert
                message="UWAGA! Zapisz zmiany przed wyjściem!"
                banner
                style={{ marginBottom: 20 }}
              />
            )}
            <Form.Item
              label="Nazwa"
              name="name"
              required
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Nazwa jest wymagana!",
                },
                {
                  pattern: name_regexp,
                  message: "Pole zawiera niedowolone znaki!",
                },
              ]}
            >
              <Input placeholder="Nazwa" maxLength={30} showCount />
            </Form.Item>
            <Form.Item
              label="Pełna nazwa"
              name="full_name"
              hasFeedback
              tooltip="Pełna nazwa typu zgłoszenia wyświetlana jako tytuł na stronie publicznego formularza"
              rules={[
                {
                  pattern: name_regexp,
                  message: "Pole zawiera niedowolone znaki!",
                },
              ]}
            >
              <Input placeholder="Pełna nazwa" maxLength={128} showCount />
            </Form.Item>
          </Card>
        );
      }}
    </Form>
  );
};

export default BasicInfo;
